<script>
	export default {
		name: "AppTabCollapseItem",
        methods: {
            getSlot() {
				// get the components
                let slot = this.$slots.default
                if (slot) {
				    return this.$slots.default.filter((vnode) => vnode.tag !== undefined)
                }
                return []
            }
        },
		render(createElement) {
            // render the component
			return createElement(
				"el-collapse-item",
				{
                    class: ['app-tab-collapse-item', 'collapse-' + this.$attrs.name],
					props: { ...this.$props },
					attrs: { ...this.$attrs },
				},
                [
                    createElement(
                        "div",
                        {
                            class: 'app-tab-collapse-item-wrapper'
                        },
                        this.getSlot()
                    )
                ]
			)
		},
	}
</script>

<style lang="scss">

    .app-tab-collapse {
        border: none !important;

        .app-tab-collapse-item {
            margin-bottom: 20px !important;

            .el-collapse-item__header {
                background: #2493ef !important;
                color: #fff !important;
                font-size: 22px !important;
                font-weight: 500 !important;
                text-transform: uppercase !important;
                text-align: center !important;
                display: block !important;
                position: relative !important;

                i {
                    position: absolute;
                    right: 5px;
                    top: 15px;
                }
            }

            .el-collapse-item__wrap {
                overflow: visible !important;
                
                .el-collapse-item__content {
                    .app-tab-collapse-item-wrapper {
                        padding: 30px;
                    }
                }
            }

            

            .el-collapse-item {
                .el-collapse-item__header {
                    background: #ffffff !important;
                    color: #333333 !important;
                    font-size: 16px !important;
                    font-weight: 500 !important;
                    text-transform: uppercase !important;
                    text-align: center !important;
                    display: block !important;
                    position: relative !important;
                    padding: 0 0 0 10px;

                    .el-tag {
                        margin: 0 50px 0 0;
                    }
                }
            }
        }
    }
</style>
